import { c as _c } from "react/compiler-runtime";
import { Tabs } from '@chakra-ui/react';
import React from 'react';

/**
 * The underlined pair under a page or a column title. It only switches; the page owns the content.
 * `flush` drops the list's own border when a parent already draws that line.
 */
export function CrmSubTabs(props) {
  const $ = _c(12);
  const t0 = props.value;
  let t1;
  if ($[0] !== props) {
    t1 = event => props.onChange(event.value as T);
    $[0] = props;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = props.ariaLabel;
  const t3 = props.flush ? "0" : undefined;
  let t4;
  if ($[2] !== props.items) {
    t4 = props.items.map(_temp);
    $[2] = props.items;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== props.ariaLabel || $[5] !== t3 || $[6] !== t4) {
    t5 = <Tabs.List aria-label={t2} borderBottomWidth={t3} w="full">{t4}</Tabs.List>;
    $[4] = props.ariaLabel;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.value || $[9] !== t1 || $[10] !== t5) {
    t6 = <Tabs.Root colorPalette="orange" size="sm" value={t0} variant="line" onValueChange={t1}>{t5}</Tabs.Root>;
    $[8] = props.value;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp(item) {
  return <Tabs.Trigger key={item.value} value={item.value}>{item.label}</Tabs.Trigger>;
}